import { NgModule } from '@angular/core';
import { My7nUiModule } from '@my7n/ui';
import { RxLet } from '@rx-angular/template/let';
import { MaterialModule } from './modules/material.module';
import { CommonModule } from '@angular/common';
import { TrustedUrlPipe } from './pipes/trusted-url.pipe';
import { MatButtonLoadingDirective } from './directive/mat-button-loading.directive';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    My7nUiModule,
    MaterialModule,
    RxLet,
    NgSelectModule
  ],
  exports: [
    CommonModule,
    My7nUiModule,
    MaterialModule,
    RxLet,
    TrustedUrlPipe,
    MatButtonLoadingDirective,
    NgSelectModule
  ],
  declarations: [
    TrustedUrlPipe,
    MatButtonLoadingDirective
  ],
  providers: []
})
export class SharedModule {}
